import axios from 'axios'

const baseURL = '/'
const client = axios.create({
    baseURL,
    responseType: 'json'
})

// intercept 401 responses and navigate to /
client.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // token is expired or not found, redirect to home
            // delete token to prevent infinte token check loop
            localStorage.removeItem('token')

            let redirect_url = '/login'
            if (window.location.pathname !== '/login' && window.location.pathname !== '/sso-login') {
                localStorage.setItem('redirect_url', `${window.location.pathname}${window.location.search}`) // save current path for redirect after login
            }

            window.location.assign(redirect_url)
        }
        return Promise.reject(error);
    }
)

export default client
